import React, { useState, useCallback, useEffect } from 'react';
import styles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import estudiantesStyles from '../../styles/EstudiantesStyles/Estudiantes.module.css';
import Sidebar from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import SearchBar from './SearchBar';
import BecasTable from './BecasTable';
import NewBecaModal from './NewBecaModal';
import ViewBecaModal from './ViewBecaModal';
import { useSidebar } from '../../components/Sidebar';
import { createBeca, updateBeca, deleteBeca, getBeca } from '../../api/becas';
import LoaderOverlay from '../../components/LoaderOverlay';
// Utilidad para mostrar Toast
const showToast = (message, type = "success") => {
  window.dispatchEvent(
    new CustomEvent("toast:show", {
      detail: { message, type, duration: 2500 },
    })
  );
};

function BecasScreen() {
  const { isCollapsed } = useSidebar();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedBeca, setSelectedBeca] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Simula fetch de datos, reemplaza por tu fetch real si es necesario
    // Por ejemplo: fetchBecas().finally(() => setLoading(false));
    setTimeout(() => setLoading(false), 1000); // Quita esto y pon tu fetch real
  }, [refreshTrigger]);

  const handleNewBeca = () => {
    setEditMode(false);
    setSelectedBeca(null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditMode(false);
    setSelectedBeca(null);
  };

  const handleViewBeca = async (beca) => {
    try {
      const becaCompleta = await getBeca(beca.id);
      console.log('Datos beca (ver):', becaCompleta);
      setSelectedBeca(becaCompleta);
      setIsViewModalOpen(true);
    } catch (error) {
      showToast('Error al consultar beca. Intenta de nuevo.', 'error');
    }
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedBeca(null);
  };

  const handleEditBeca = async (beca) => {
    try {
      const becaCompleta = await getBeca(beca.id);
      console.log('Datos beca (editar):', becaCompleta);
      setSelectedBeca(becaCompleta);
      setEditMode(true);
      setIsModalOpen(true);
    } catch (error) {
      showToast('Error al consultar beca. Intenta de nuevo.', 'error');
    }
  };

  const handleDeleteBeca = async (beca) => {
    if (window.confirm(`¿Está seguro de eliminar la beca "${beca.nombre}"?`)) {
      try {
        await deleteBeca(beca.id);
        setRefreshTrigger(prev => prev + 1); // Refresh table
        showToast('Beca eliminada correctamente', 'success');
        window.alert('¡Eliminación exitosa!');
      } catch (error) {
        console.error('Error al eliminar beca:', error);
        showToast('Error al eliminar la beca. Por favor intenta de nuevo.', 'error');
      }
    }
  };

  const handleSaveBeca = async (backendData) => {
    try {
      if (editMode && selectedBeca) {
        // Actualizar beca existente
        await updateBeca(selectedBeca.id, backendData);
        showToast('Beca actualizada correctamente', 'success');
        window.alert('¡Edición exitosa!');
      } else {
        // Crear nueva beca
        await createBeca(backendData);
        showToast('Beca registrada correctamente', 'success');
        window.alert('¡Registro exitoso!');
      }
      setIsModalOpen(false);
      setEditMode(false);
      setSelectedBeca(null);
      setRefreshTrigger(prev => prev + 1); // Trigger table refresh
    } catch (error) {
      console.error('Error al guardar beca:', error);
      // Extraer mensaje de error del backend para mostrarlo al usuario
      let mensajeError = 'Error al guardar la beca. Intenta de nuevo.';
      const data = error?.response?.data;
      if (data) {
        if (typeof data === 'string') {
          mensajeError = data;
        } else if (data.detail) {
          mensajeError = data.detail;
        } else if (typeof data === 'object') {
          // DRF devuelve {campo: ["mensaje"]} — tomar el primer mensaje útil
          const primeraClave = Object.keys(data)[0];
          if (primeraClave) {
            const valor = data[primeraClave];
            const texto = Array.isArray(valor) ? valor[0] : valor;
            mensajeError = `${primeraClave}: ${texto}`;
          }
        }
      } else if (error?.message) {
        mensajeError = error.message;
      }
      showToast(mensajeError, 'error');
      // Relanzar para que el modal mantenga el estado y permita reintentar
      throw error;
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={`${styles.layout} ${isCollapsed ? styles.sidebarCollapsedLayout : ''}`}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <main className={styles.mainContent}>
            <HeaderGlobal title="Becas" />
            <div className={styles.contentArea}>
              <div className={styles.contentWrapper} style={{ position: 'relative' }}>
                <LoaderOverlay visible={loading} label="Cargando becas..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={styles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar Beca..."
                          value={query}
                          onChange={e => setQuery(e.target.value)}
                        />
                      </div>
                      <button
                        className={styles.buscarButtonProgramas}
                        type="button"
                        tabIndex={-1}
                        style={{ pointerEvents: 'none', opacity: 0.7 }}
                      >
                        Buscar
                      </button>
                      <button
                        className={styles.newProgramButton}
                        onClick={handleNewBeca}
                      >
                        + Nueva Beca
                      </button>
                    </div>
                  </div>
                </div>
                <BecasTable 
                  refreshTrigger={refreshTrigger}
                  onView={handleViewBeca}
                  onEdit={handleEditBeca}
                  onDelete={handleDeleteBeca}
                  query={query}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      {isModalOpen && (
        <NewBecaModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSave={handleSaveBeca}
          editMode={editMode}
          becaData={selectedBeca}
        />
      )}
      {isViewModalOpen && (
        <ViewBecaModal
          isOpen={isViewModalOpen}
          onClose={handleCloseViewModal}
          beca={selectedBeca}
        />
      )}
    </div>
  );
}

export default BecasScreen;
